import Vue from "vue";
import Vuex from "vuex";
import moment from "moment";
import * as modules from "./modules";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    i18n: null,
    staticRoot: "/data/static/",
    api: null
  },
  getters: {
    locale: state => {
      let user_locale = store.getters["user/settingsLocale"];
      if (user_locale) {
        store.commit("setLocale", user_locale);
      }
      return state.i18n.locale;
    }
  },
  mutations: {
    setI18N(state, data) {
      state.i18n = data;
    },
    setLocale(state, locale) {
      if (Object.keys(state.i18n.messages).includes(locale)) {
        Vue.prototype.$localStorage.set("locale", (state.i18n.locale = locale));
        moment.locale(locale === "ua" ? "uk" : locale);
      }
    },
    setStaticRoot(state, data) {
      state.staticRoot = data;
    },
    setAPI(state, data) {
      state.api = data;
    }
  },
  modules
});
export default store;
